import { render, staticRenderFns } from "./Sequence.token.vue?vue&type=template&id=2d1170d0&"
import script from "./Sequence.token.vue?vue&type=script&lang=ts&"
export * from "./Sequence.token.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports